import './global.css';

import type { Page } from '@/types';
import type { RouteObject } from 'react-router-dom';

import AppLayout from '@/AppLayout';
import AppLoader from '@/AppLoader';
import AppPageTemplate from '@/AppPageTemplate';
import { AuthInitializer } from '@/components/auth/AuthInitializer';
import { appPages, appHomePage } from '@/store/reducerApp';
import { lazy } from 'react';
import { useSelector } from 'react-redux';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';

const Page404 = lazy(() => import('@/pages/error/404'));
const Page500 = lazy(() => import('@/pages/error/500'));

function buildBrowseRouter(pages: Page[], homePage: string) {
  const children: RouteObject[] = [];
  pages.forEach((page) => {
    const route: RouteObject = {
      path: page.uri,
      element: <AppPageTemplate uri={page.uri} template={page.template} />,
    };
    children.push(route);
  });

  if (!children?.length) {
    children.push({ path: '*', element: <AppLoader /> });
  } else {
    children.push({ path: '/', element: <Navigate to={homePage} /> });
    children.push({ path: '*', element: <Page404 /> });
  }

  const routesSection: RouteObject[] = [
    {
      Component: () => (
        <AppLayout>
          <Outlet />
        </AppLayout>
      ),
      errorElement: <Page500 />,
      children,
    },
  ];

  return createBrowserRouter(routesSection);
}

const App: React.FC = () => {
  const pages = useSelector(appPages);
  const home = useSelector(appHomePage);
  const router = buildBrowseRouter(pages || [], home);

  return (
    <>
      <AuthInitializer />
      <RouterProvider router={router} />
    </>
  );
};

export default App;
